<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
(function() {
  function forceSliderAutoplay() {
    // Ella theme uses Slick slider
    const sliders = document.querySelectorAll('.slideshow, [data-slick]');
    
    sliders.forEach(function(slider) {
      if (slider.slick) {
        // Force pauseOnHover to false
        slider.slick.options.pauseOnHover = false;
        slider.slick.options.pauseOnFocus = false;
        
        // Restart autoplay
        slider.slick.slickPlay();
      }
      
      // Override hover events
      slider.addEventListener('mouseenter', function(e) {
        if (this.slick) {
          this.slick.slickPlay();
        }
      });
    });
  }
  
  // Run after Slick initializes
  setTimeout(forceSliderAutoplay, 500);
  document.addEventListener('DOMContentLoaded', forceSliderAutoplay);
})();
